<mat-accordion class="relatorio-geral-imovel-accordion">
    
    <ng-container >
        <mat-expansion-panel [expanded]="true" class="relatorio-geral-imovel-panel">
            <mat-expansion-panel-header>
                <mat-panel-title id="layer-header" class="layers-col">
                    <mat-icon class="material-icons layer-icon">description</mat-icon>Relatório Geral do Imóvel
                </mat-panel-title>
                <mat-panel-description>
                </mat-panel-description>
              
            </mat-expansion-panel-header>
            <div class="form">
                  <mat-form-field appearance="fill">
                    <mat-label>Inscrição </mat-label>
                    <mat-select required [(ngModel)]="ic" class="property-value">
                        <mat-option *ngFor="let inscricao of ics" [value]="inscricao" required>
                        {{inscricao}}
                        </mat-option>
                    </mat-select>
                 </mat-form-field>   
               <div class="generate-button">
                <button type="button" (click)="generate()" mat-raised-button color="primary" id="generate-button" [disabled]="downloading">
                    <span class="material-icons">download</span> Gerar
                </button>

              </div>  
            </div> 

            
            </mat-expansion-panel>

    </ng-container>
</mat-accordion>
<div id="temp-map-div" style="display: none;"></div>